<h1 mat-dialog-title>Select outlets by property @if (res && res.total) {
  <small> ({{ res?.total }} outlets)</small>
}</h1>
<div mat-dialog-content>
  <div fxLayout="row" fxFlexFill fxLayoutGap="10px">
    <div fxFlex>
      <app-outlet-properties #outletPropertiesView [readOnly]="false" [placeholder]="'Outlet properties - format [property:value]'" [labels]="outletProperties" (changed)="onOutletPropertiesChanged()"></app-outlet-properties>
    </div>
    <div fxFlex="100px" class="actions">
      <button mat-raised-button color="primary" (click)="onSearch()"><mat-icon>search</mat-icon> Search</button>
    </div>
  </div>
  <div class="table" style="width: 100%;" >
    @if (isLoading) {
      <mat-progress-spinner mode="indeterminate" color="primary" [diameter]="40"></mat-progress-spinner>
    }
    <table [class.grid-loading]="isLoading" mat-table [dataSource]="outlets" [hidden]="isLoading" style="width: 100%;">
      <ng-container matColumnDef="state">
        <th mat-header-cell *matHeaderCellDef> State </th>
        <td mat-cell *matCellDef="let element"> {{ element.state }} </td>
      </ng-container>
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef> Name </th>
        <td mat-cell *matCellDef="let element"> {{ element.name }} </td>
      </ng-container>
      <ng-container matColumnDef="formattedAddress">
        <th mat-header-cell *matHeaderCellDef> Address </th>
        <td mat-cell *matCellDef="let element"> {{ element.formattedAddress }} </td>
      </ng-container>
      <ng-container matColumnDef="vendorName">
        <th mat-header-cell *matHeaderCellDef> Vendor name </th>
        <td mat-cell *matCellDef="let element"> {{ element.vendorName }} </td>
      </ng-container>
      <ng-container matColumnDef="externalId">
        <th mat-header-cell *matHeaderCellDef> External Id </th>
        <td mat-cell *matCellDef="let element"> {{ element.externalId }} </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="['state', 'name', 'formattedAddress', 'vendorName', 'externalId']"></tr>
      <tr mat-row *matRowDef="let row; columns: ['state', 'name', 'formattedAddress', 'vendorName', 'externalId'];"></tr>
    </table>
  </div>
</div>
<div mat-dialog-actions>
  <button mat-raised-button color="primary" (click)="onSelect()">Select properties</button>
  <button mat-button [mat-dialog-close]="">Cancel</button>
</div>
